import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import MinimizeIcon from '@atlaskit/icon/core/minimize';

type MinimizeButtonProps = {
	minimizePopup: () => void;
};

type CloseButtonProps = {
	closePopup: () => void;
};

type ControlButtonProps = {
	closePopup: () => void;
	isPlaying?: boolean;
	minimizePopup?: () => void;
};

const MinimizeButton = ({ minimizePopup }: MinimizeButtonProps): JSX.Element => {
	return (
		<IconButton
			icon={MinimizeIcon}
			label="minimizeIcon"
			appearance="subtle"
			shape="circle"
			spacing="compact"
			onClick={minimizePopup}
			testId="briefings-minimize-button"
		/>
	);
};

const CloseButton = ({ closePopup }: CloseButtonProps): JSX.Element => {
	return (
		<IconButton
			icon={CrossIcon}
			label="closeIcon"
			appearance="subtle"
			shape="circle"
			spacing="compact"
			onClick={closePopup}
			testId="briefings-close-button"
		/>
	);
};

export const AudioBriefingPopupControlButton = ({
	isPlaying = false,
	minimizePopup,
	closePopup,
}: ControlButtonProps): JSX.Element => {
	if (isPlaying && minimizePopup) {
		return <MinimizeButton minimizePopup={minimizePopup} />;
	}

	return <CloseButton closePopup={closePopup} />;
};
